import { render, staticRenderFns } from "./OrgView.vue?vue&type=template&id=0c8350cc&scoped=true&"
import script from "./OrgView.vue?vue&type=script&lang=ts&"
export * from "./OrgView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8350cc",
  null
  
)

export default component.exports